import { useSelector } from 'react-redux';
import { Transfer } from 'src/models';

const EMPTY_TRANSFERS: Transfer[] = [];

export interface UseTransferListSelectorReturnType {
  transferList: Transfer[];
  isTransferListLoading: boolean;
  hasTransferListError: boolean;
  transferListError?: string;
}

export const useTransferListSelector = (): UseTransferListSelectorReturnType => {
  const transferList: Transfer[] | undefined = useSelector((state: any) => state.cashiering.transfers?.data);
  const isTransferListLoading = useSelector((state: any) => Boolean(state.cashiering.transfers?.isLoading));
  const hasTransferListFailed: boolean = useSelector((state: any) => state.cashiering.transfers?.__failed);
  const transferListError: string = useSelector((state: any) => state.cashiering.transfers?.__message);

  return {
    transferList: Array.isArray(transferList) ? transferList : EMPTY_TRANSFERS,
    isTransferListLoading,
    hasTransferListError: hasTransferListFailed,
    transferListError,
  };
};
